import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import { Button, Card, type CardProps, Box, Flex, Text } from '@mantine/core'

import {
  useQueryGetAllBookingServices,
  useQueryGetBookingById,
} from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { type ParameterID } from '@flecto/types'
import { Icon } from '@flecto/ui'

import { useModalBookingService } from '../../hooks/useModalBookingService'
import { TableBookingServices } from '../TableBookingServices/TableBookingServices'

export type CardBookingServicesSelectionProps = Omit<CardProps, 'children'> & {
  bookingId?: ParameterID
}

export function CardBookingServicesSelection({
  bookingId,
  ...props
}: CardBookingServicesSelectionProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_services' })

  const { openModal } = useModalBookingService({ bookingId })

  const { data: booking, isLoading: isLoadingBooking } = useQueryGetBookingById(
    { bookingId }
  )

  const { data: bookingServices } = useQueryGetAllBookingServices({
    bookingId,
  })

  return (
    <Card {...props} withBorder>
      <Flex align='center' justify='space-between'>
        <Box style={{ flex: 1 }}>
          <Text fw={500}>{t('label_services')}</Text>
          <Text c='dimmed' size='sm'>
            {t('card_services_selection_description')}
          </Text>
        </Box>
      </Flex>
      {Boolean(bookingServices?.booking_service.length) && (
        <TableBookingServices
          mt='md'
          bookingId={bookingId}
          bookingServices={bookingServices?.booking_service}
          isLoading={isLoadingBooking}
          withBorder={false}
          withPagination={false}
        />
      )}
      <Button
        mt='md'
        variant='outline'
        onClick={openModal}
        disabled={
          !booking?.start_at ||
          !booking.end_at ||
          booking.status === 'canceled' ||
          booking.status === 'completed'
        }
        leftSection={<Icon icon={faPlus} />}
      >
        {t('label_add_service')}
      </Button>
    </Card>
  )
}
